// IsoscelesTrapezoidDiagram.js
import React from "react";

export default function IsoscelesTrapezoidDiagram({
  a,
  b,
  c,
  size = 360,
  padTop = 56,
  padBottom = 40,
  padX = 40,
  strokeW = 2.8,
  style,
  className,
}) {
  const A = Math.max(1, Number(a) || 1);
  const B = Math.max(1, Number(b) || 1);
  const C = Math.max(1, Number(c) || 1);

  const x = (B - A) / 2;
  const disc = Math.max(0, C * C - x * x);
  const h = Math.sqrt(disc);

  const W = size;
  const H = Math.round(size * 0.58);

  const innerW = W - 2 * padX;
  const innerH = H - padTop - padBottom;

  const unit = innerW / B;

  const baseY = padTop + innerH * 0.78;
  const topY = baseY - h * unit - 2;

  const leftX = padX;
  const rightX = padX + B * unit;

  const topLeftX = leftX + x * unit;
  const topRightX = topLeftX + A * unit;

  const COLORS = {
    accent: "#f59e0b",   // etykiety a, b, c
    height: "#10b981",   // wysokość h (zielona)
    arm: "currentColor", // <<< ramiona dziedziczą kolor motywu
    base: "currentColor",// <<< podstawy dziedziczą kolor motywu
    xLine: "#8b5cf6",    // odcinki x (fiolet)
    xLabel: "#8b5cf6",   // podpis x (fiolet)
  };

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="xMidYMid meet"
      className={className}
      style={{
        display: "block",
        margin: "0 auto",
        width: "100%",
        height: "auto",
        maxWidth: W,
        overflow: "visible",
        ...style,
      }}
    >
      {/* podstawy */}
      <line x1={leftX} y1={baseY} x2={rightX} y2={baseY}
            stroke={COLORS.base} strokeWidth={strokeW} strokeLinecap="round" />
      <line x1={topLeftX} y1={topY} x2={topRightX} y2={topY}
            stroke={COLORS.base} strokeWidth={strokeW} strokeLinecap="round" />

      {/* ramiona */}
      <line x1={leftX} y1={baseY} x2={topLeftX} y2={topY}
            stroke={COLORS.arm} strokeWidth={strokeW} strokeLinecap="round" />
      <line x1={rightX} y1={baseY} x2={topRightX} y2={topY}
            stroke={COLORS.arm} strokeWidth={strokeW} strokeLinecap="round" />

      {/* wysokość h */}
      <line x1={topLeftX} y1={topY} x2={topLeftX} y2={baseY}
            stroke={COLORS.height} strokeWidth={strokeW} strokeLinecap="round" />

      {/* odcięte x */}
      <line x1={leftX} y1={baseY + 6} x2={topLeftX} y2={baseY + 6}
            stroke={COLORS.xLine} strokeWidth={strokeW} strokeLinecap="round" />
      <line x1={topRightX} y1={baseY + 6} x2={rightX} y2={baseY + 6}
            stroke={COLORS.xLine} strokeWidth={strokeW} strokeLinecap="round" />

      {/* podpisy */}
      <text x={(leftX + rightX) / 2} y={baseY + 18}
            fontSize="13" fill={COLORS.accent} textAnchor="middle">{`b=${b}`}</text>
      <text x={(topLeftX + topRightX) / 2} y={topY - 8}
            fontSize="13" fill={COLORS.accent} textAnchor="middle">{`a=${a}`}</text>
      {/* c na zewnątrz */}
      <text x={leftX - 10} y={(baseY + topY) / 2}
            fontSize="13" fill={COLORS.accent} textAnchor="end">{`c=${c}`}</text>
      <text x={rightX + 10} y={(baseY + topY) / 2}
            fontSize="13" fill={COLORS.accent} textAnchor="start">{`c=${c}`}</text>
      {/* h */}
      <text x={topLeftX + 6} y={(baseY + topY) / 2}
            fontSize="13" fill={COLORS.height}>h</text>
      {/* x */}
      <text x={(leftX + topLeftX) / 2} y={baseY + 22}
            fontSize="13" fill={COLORS.xLabel} textAnchor="middle">x</text>
      <text x={(topRightX + rightX) / 2} y={baseY + 22}
            fontSize="13" fill={COLORS.xLabel} textAnchor="middle">x</text>
    </svg>
  );
}
